import React, { useCallback } from 'react';
import { withStyles, Checkbox, FormControlLabel, Chip, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { FIELDS } from './UserFormContainer';
import { ApiAutocomplete, PasswordInput, TextInput } from '../../common';
import { getCookie } from '../../../utils/utils';
import styles from './styles';
import UserAccessGroupsComponent from './UserAccessGroupsComponent';

const UserFormComponent = ({
  classes,
  errors,
  handleChange,
  handleChangeAutocomplete,
  handleChangeServiceUser,
  handleBlur,
  loadingPermissions,
  values,
  editMode,
  isNewUser,
  permissions,
  handleChangePermission,
  handleChangeCategory,
  availableGroups,
}) => {
  const isCurrentUser = getCookie('userId') === values?._id;

  const handleChangeRole = useCallback(value => handleChangeAutocomplete('role', value), [
    handleChangeAutocomplete,
  ]);

  return (
    <>
      <p className={classes.sectionTitle} style={{ marginTop: 10 }}>
        Información de la cuenta:{' '}
      </p>
      <TextInput
        name="firstName"
        value={values.firstName}
        error={errors.firstName}
        handleChange={handleChange}
        handleBlur={handleBlur}
        label={FIELDS['firstName']}
        disabled={!editMode}
        hide={!editMode && !values.firstName}
      />
      <TextInput
        name="lastName"
        value={values.lastName}
        error={errors.lastName}
        handleChange={handleChange}
        handleBlur={handleBlur}
        label={FIELDS['lastName']}
        disabled={!editMode}
        hide={!editMode && !values.lastName}
      />
      <TextInput
        name="email"
        value={values.email}
        error={errors.email}
        handleChange={handleChange}
        handleBlur={handleBlur}
        label={FIELDS['email']}
        disabled={!editMode}
        hide={!editMode && !values.email}
      />
      {isNewUser && (
        <PasswordInput
          name="password"
          error={errors.password}
          handleChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          label={FIELDS['password']}
          hideStartAdornment
          InputProps={{
            autoComplete: 'new-password',
          }}
        />
      )}
      <Autocomplete
        multiple
        disableCloseOnSelect
        disabled={!editMode}
        options={availableGroups.map(g => g.group)}
        value={values.groups || []}
        onChange={(_, newValue) =>
          handleChange({ target: { name: 'groups', value: newValue } })
        }
        noOptionsText="No hay grupos"
        renderOption={(option, { selected }) => (
          <>
            <Checkbox checked={selected} style={{ marginRight: 4 }} />
            {option}
          </>
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip label={option} size="small" {...getTagProps({ index })} />
          ))
        }
        renderInput={params => (
          <TextField
            {...params}
            label={FIELDS['groups']}
            margin="normal"
            error={!!errors.groups}
            helperText={errors.groups}
          />
        )}
      />
      <FormControlLabel control={<Checkbox name='isServiceUser' value={values.isServiceUser} checked={values.isServiceUser ? true : false} onChange={handleChangeServiceUser} disabled={!editMode} />} label="Usuario de servicio" />
      { !editMode && <UserAccessGroupsComponent classes={classes} values={values} /> }
    </>
  );
};

export default withStyles(styles)(UserFormComponent);
